export const toolOptions = [
  { value: 1, label: "Rice Mill" },
  { value: 2, label: "Grain Drying Facility" },
  { value: 3, label: "Warehouse" },
  { value: 4, label: "Thresher" },
  { value: 5, label: "Hand Tractor" },
  { value: 6, label: "Araro" },
  { value: 7, label: "Suyod" },
  { value: 8, label: "Waterpump" },
  { value: 9, label: "Sima o pangawit (barb)" },
  { value: 10, label: "Hudhod" },
  { value: 11, label: "Lambat o salambaw" },
  { value: 12, label: "Municipal fishing vessel" },
  { value: 13, label: "Commercial fishing vessel" },
  { value: 14, label: "Non-motorized fishing boat" },
  { value: 15, label: "Bubo" },
  { value: 16, label: "Blower (palay)" },
  { value: 17, label: "Weeder" },
  { value: 18, label: "Sprayer (knapsack)" },
  { value: 19, label: "Kaladkad" },
  { value: 20, label: "Gapas" },
  { value: 21, label: "Feedmill" },
  { value: 22, label: "Reaper" },
  { value: 23, label: "Corn Sheller" },
  { value: 24, label: "4-wheel tractor" },
  { value: 25, label: "Sprayer (power)" },
  { value: 26, label: "Grasscutter" },
  { value: 27, label: "Combined harvester/thresher" },
  { value: 28, label: "Mechanical transplanter" },
  { value: 29, label: "Drum seeder" },
  { value: 30, label: "Mud boat (turtle)" },
  { value: 31, label: "Rotary weeder" },
  { value: 32, label: 'Others, specify'}
];
export const productOptions = [
  { value: 1, label: "1 - Palay" },
  { value: 2, label: "2 - Mais" },
  { value: 3, label: "3 - Ampalaya" },
  { value: 4, label: "4 - Cabbage" },
  { value: 5, label: "5 - Camote tops" },
  { value: 6, label: "6 - Carrots" },
  { value: 7, label: "7 - Talong" },
  { value: 8, label: "8 - Bawang" },
  { value: 9, label: "9 - Luya" },
  { value: 10, label: "10 - Patola" },
  { value: 11, label: "11 - Habitchuelas" },
  { value: 12, label: "12 - Mongo" },
  { value: 13, label: "13 - Sibuyas" },
  { value: 14, label: "14 - Mani" },
  { value: 15, label: "15 - Pechay" },
  { value: 16, label: "16 - Patatas" },
  { value: 17, label: "17 - Kalabasa" },
  { value: 18, label: "18 - Stringbeans" },
  { value: 19, label: "19 - Kamatis" },
  { value: 20, label: "20 - Camote" },
  { value: 21, label: "21 - Cassava" },
  { value: 22, label: "22 - Gabi" },
  { value: 23, label: "23 - Saging" },
  { value: 24, label: "24 - Calamansi" },
  { value: 25, label: "25 - Manga" },
  { value: 26, label: "26 - Papaya" },
  { value: 27, label: "27 - Pinya" },
  { value: 28, label: "28 - Watermelon" },
  { value: 29, label: "29 - Abaca" },
  { value: 30, label: "30 - Coconut" },
  { value: 31, label: "31 - Coffee" },
  { value: 32, label: "32 - Rubber" },
  { value: 33, label: "33 - Sugarcane" },
  { value: 34, label: "34 - Tobacco" },
  { value: 35, label: "35 - at iba pa" },
];
export const landTypeOptions = [
  { value: 1, label: "1 - Lowland/Irrigated (Shallow Tube Well - STW)" },
  { value: 2, label: "2 - Lowland/Rainfed" },
  { value: 3, label: "3 - Lowland/Irrigated (NIA)" },
  { value: 4, label: "4 - Lowland/Irrigated (Small Farm Reservoir - SFR)" },
  { value: 5, label: "5 - Upland/Irrigated (Shallow Tube Well)" },
  { value: 6, label: "6 - Upland/Rainfed" },
  { value: 7, label: "7 - Upland/Irrigated (NIA)" },
  { value: 8, label: "8 - Upland/Irrigated (Small Farm Reservoir - SFR)" },
  { value: 9, label: "9 - Mangrove Forest" },
];
export const areaUnits = [
  { value: "hectares", label: "hectares", factor: 1 },
  { value: "sqm", label: "sqm", factor: 0.0001 },
];
export const assistanceSource = [
  { value: 1, label: "1 - National Government" },
  { value: 2, label: "2 - Regional Government" },
  { value: 3, label: "3 - Provincial Government" },
  { value: 4, label: "4 - City/Municipal Government" },
  { value: 5, label: "5 - Barangay Government" },
  { value: 6, label: "6 - NGO" },
  { value: 7, label: "7 - Private Organization" },
  { value: 8, label: "8 - Private Person" },
  { value: 9, label: "9 - International Organization" },
  { value: 99, label: "99 - Others, specify" },
];
export const assistanceType = [
  { value: 1, label: "1 - Pagkain at tubig" },
  { value: 2, label: "2 - Damit at personal na gamit" },
  { value: 3, label: "3 - Materyales sa pagpapagawa ng bahay" },
  { value: 4, label: "4 - Pera" },
  { value: 5, label: "5 - Hygiene kit" },
  { value: 6, label: "6 - Psychosocial support" },
  { value: 99, label: "99 - Others, specify" },
];
export const animalsForFood = [
  { value: 1, description: "1 - Pig (Baboy)" },
  { value: 2, description: "2 - Chicken-Chick(young)" },
  { value: 3, description: "3 - Cattle-Cow(female)" },
  { value: 4, description: "4 - Carabao" },
  { value: 5, description: "5 - Goat-Buck(Male)" },
  { value: 6, description: "6 - Horse-Stallion(Male)" },
  { value: 7, description: "7 - Pabo (Turkey)" },
  { value: 8, description: "8 - Duck-Drake(Male)" },
  { value: 9, description: "9 - Pugo (Quail)" },
  { value: 10, description: "10 - Duck-Duck(female)" },
  { value: 17, description: "17 - Kabir" },
  { value: 18, description: "18 - Palakang Bukid" },
  { value: 19, description: "19 - Swan" },
  { value: 20, description: "20 - Gansa (Goose)" },
  { value: 21, description: "21 - Saso" },
  { value: 22, description: "22 - Manok (Native)" },
  { value: 23, description: "23 - Deer (Usa)" },
  { value: 24, description: "24 - Native Goat" },
  { value: 25, description: "25 - Boar-Boar(Male)" },
  { value: 26, description: "26 - Sheep-Buck(Male)" },
  { value: 27, description: "27 - Others" },
  { value: 28, description: "28 - F1 Carabao" },
  { value: 29, description: "29 - Baka, Native" },
  { value: 30, description: "30 - Hog-Boar(Male)" },
  { value: 31, description: "31 - Hog-Sow(female)" },
  { value: 32, description: "32 - Hog-Farrow(young)" },
  { value: 33, description: "33 - Hog-Shoat(young)" },
  { value: 35, description: "35 - Manok (sasabungin)" },
  { value: 36, description: "36 - Chicken-Hen(female)" },
  { value: 37, description: "37 - Chicken-Cockerel (rooster)(young)" },
  { value: 38, description: "38 - Bangala" },
  { value: 39, description: "39 - Ostrich" },
  { value: 40, description: "40 - Boar-Piglet(young)" },
  { value: 41, description: "41 - Boar-Sow(female)" },
  { value: 42, description: "42 - Cattle-Bull(Male)" },
  { value: 43, description: "43 - Cattle-Calf(young)" },
  { value: 44, description: "44 - Chicken-Pullet (hen)(young)" },
  { value: 45, description: "45 - Chicken-Rooster(Male)" },
  { value: 46, description: "46 - Deer-(female)" },
  { value: 47, description: "47 - Deer-(young)" },
  { value: 48, description: "48 - Deer-Buck(Male)" },
  { value: 49, description: "49 - Deer-Doe(female)" },
  { value: 50, description: "50 - Deer-Fawn(young)" },
  { value: 51, description: "51 - Deer-Stag(Male)" },
  { value: 52, description: "52 - Duck-Duckling(young)" },
  { value: 53, description: "53 - Duck-Hen(female)" },
  { value: 54, description: "54 - Goat-(female)" },
  { value: 55, description: "55 - Goat-(young)" },
  { value: 56, description: "56 - Goat-Billy(Male)" },
  { value: 57, description: "57 - Goat-Kid(young)" },
  { value: 58, description: "58 - Goat-Nanny(female)" },
  { value: 59, description: "59 - Goose-Gander(female)" },
  { value: 60, description: "60 - Goose-Gander(Male)" },
  { value: 61, description: "61 - Goose-Goose(female)" },
  { value: 62, description: "62 - Goose-Goose(Male)" },
  { value: 63, description: "63 - Goose-Gosling(young)" },
  { value: 64, description: "64 - Guinea Pig-Boar(Male)" },
  { value: 65, description: "65 - Guinea Pig-Pup(young)" },
  { value: 66, description: "66 - Guinea Pig-Sow(female)" },
  { value: 67, description: "67 - Horse-Colt (Male)(young)" },
  { value: 68, description: "68 - Horse-Dam(female)" },
  { value: 69, description: "69 - Horse-Filly (Female)(young)" },
  { value: 70, description: "70 - Horse-Foal(young)" },
  { value: 71, description: "71 - Horse-Mare(female)" },
  { value: 72, description: "72 - Horse-Stud(Male)" },
  { value: 73, description: "73 - Ostrich-Chick(young)" },
  { value: 74, description: "74 - Ostrich-Cock(Male)" },
  { value: 75, description: "75 - Ostrich-Hen(female)" },
  { value: 76, description: "76 - Ox-Bull(Male)" },
  { value: 77, description: "77 - Ox-Calf(young)" },
  { value: 78, description: "78 - Ox-Cow(female)" },
  { value: 79, description: "79 - Pig-Boar(Male)" },
  { value: 80, description: "80 - Pig-Piglet(young)" },
  { value: 81, description: "81 - Pig-Sow(female)" },
  { value: 82, description: "82 - Sheep-(female)" },
  { value: 83, description: "83 - Sheep-(young)" },
  { value: 84, description: "84 - Sheep-Ewe(female)" },
  { value: 85, description: "85 - Sheep-Lamb(young)" },
  { value: 86, description: "86 - Sheep-Ram(Male)" },
  { value: 87, description: "87 - Swan-Cob(Male)" },
  { value: 88, description: "88 - Swan-Cygnet(young)" },
  { value: 89, description: "89 - Swan-Pen(female)" },
  { value: 90, description: "90 - Swine-Boar(Male)" },
  { value: 91, description: "91 - Swine-Piglet(young)" },
  { value: 92, description: "92 - Swine-Sow(female)" },
];
export const animalsForPets = [
  { value: 1, description: "1 - Dog (Aso)" },
  { value: 2, description: "2 - Cat (Pusa)" },
  { value: 3, description: "3 - Bird (Ibon)" },
  { value: 4, description: "4 - Monkey" },
  { value: 5, description: "5 - Rabbit" },
  { value: 6, description: "6 - Aquarium fish" },
  { value: 7, description: "7 - Snake (Ahas)" },
  { value: 8, description: "8 - Turtle (Pagong)" },
  { value: 9, description: "9 - Pigeon" },
  { value: 10, description: "10 - Iguana" },
  { value: 11, description: "11 - Hamster" },
  { value: 12, description: "12 - Guinea Pig" },
  { value: 13, description: "13 - Spider" },
  { value: 14, description: "14 - Other reptiles and amphibians" },
  { value: 15, description: "15 - Other" },
  { value: 16, description: "16 - Saltwater fish" },
  { value: 17, description: "17 - Other small animals" },
];
export const vesselTypeOptions = [
  { value: "1", label: "Non-motorized" },
  { value: "2", label: "Motorized" },
  { value: "3", label: "Others specify:" },
];
export const materialUsedOptions = [
  { value: "1", label: "Wood" },
  { value: "2", label: "Fiber Glass" },
  { value: "3", label: "Composite" },
];
export const civilStatusOptions = [
  { label: "M - Married" },
  { label: "S - Single" },
  { label: "NM - Not Married/Common Law" },
  { label: "A - Anulled" },
  { label: "W - Widow/Widower" },
  { label: "LS - Legally Separated" },
  { label: "Sep - Separated" },
  { label: "D - Divorced" },
];
export const cookingFacOptions = [
  { value: 1, label: "1 - Electricity" },
  { value: 2, label: "2 - Charcoal" },
  { value: 3, label: "3 - Kerosene (Gaas)" },
  { value: 4, label: "4 - LPG" },
  { value: 5, label: "5 - Wood" },
  { value: 6, label: "6 - Biogas" },
  { value: 99, label: "99 - Others, specify" },
];
export const landOwnershipOptions = [
  { value: 1, label: "1 - Leased" },
  { value: 2, label: "2 - Owned" },
  { value: 3, label: "3 - Tenant" },
  { value: 4, label: "4 - CARP Beneficiary" },
  { value: 5, label: "5 - Farm out/subcontract" },
  { value: 6, label: "6 - Government-owned with consent to farm" },
  { value: 7, label: "7 - Government-owned without consent to farm" },
  { value: 8, label: "8 - Sania" },
  { value: 9, label: "9 - Family-owned" },
  { value: 10, label: "10 - Others, specify:" },
];
export const disasterImpactOptions = [
  { value: 1, label: "1 - Nasira ang bahay" },
  { value: 2, label: "2 - Nasira ang pananim" },
  { value: 3, label: "3 - Nasira ang kagamitan" },
  { value: 4, label: "4 - Nagtamo ng injury" },
  { value: 5, label: "5 - Walang epekto o damage" },
  { value: 6, label: "6 - Namatayan" },
  { value: 99, label: "99 - Others, specify" },
];
export const disasterTypeOptions = [
  { value: 1, label: "1 - Bagyo" },
  { value: 2, label: "2 - Baha" },
  { value: 3, label: "3 - Lindol" },
  { value: 4, label: "4 - Tsunami" },
  { value: 5, label: "5 - Pagguho ng lupa" },
  { value: 6, label: "6 - Pagsabog ng bulkan" },
  { value: 7, label: "7 - Man-made calamity" },
  { value: 99, label: "99 - Others, specify" },
];
export const ecologicalSettingOptions = [
  { value: 1, label: "1 - Coastal" },
  { value: 2, label: "2 - Lowland" },
  { value: 3, label: "3 - Upland" },
];
export const waterAvailabilityOptions = [{ label: "Yes" }, { label: "No" }];
export const waterLocations = [
  { label: "In Own Dwelling" },
  { label: "In Own Yard/Plot" },
  { label: "Elsewhere" },
];
export const toiletSharingOptions = [
  { label: "Household members only" },
  { label: "Other known household" },
  { label: "Shared with public" },
];
export const garbageDisposalOptions = [
  { label: "Burned" },
  { label: "Collected by Barangay" },
  { label: "Collected by City/Municipality" },
  { label: "Dumped in Compost Pit" },
  { label: "Dumped in Open Pit" },
  { label: "Dumped in River/Creek" },
  { label: "Dumped on Empty Lots" },
  { label: "Practiced Segregation" },
  { label: "Practiced Recycling/Reusing" },
  { label: "Others, specify" },
];
export const toiletFacilities = [
  { label: "Pour/Flush to Piped Sewer" },
  { label: "Pour/Flush to Septic Tank" },
  { label: "Pour/Flush to Pit Latrine" },
  { label: "Ventilated Improved Latrine" },
  { label: "Pit Latrine with Slab" },
  { label: "Pour/Flush to Open Drain" },
  { label: "Pit Latrine without Slab/Open Pit" },
  { label: "Bucket/Pail System" },
  { label: "Hanging Toilet/Hanging Latrine" },
  { label: "Public Toilet" },
  { label: "No Facility" },
  { label: "Disposal of Human Feces Elsewhere" },
  { label: "Others, specify" },
];
export const waterSourceOptions = [
  { label: "Dug Well (Balon)" },
  { label: "Barangay Water System" },
  { label: "Tubed/Piped Well (>25m)" },
  { label: "Tubed/Piped Shallow Well (<25m)" },
  { label: "Spring, Lake, River, or Rain" },
  { label: "Peddler" },
  { label: "Water District Directly to Household" },
  { label: "Mineral/Bottled Water" },
  { label: "Tanker Truck" },
  { label: "Public Tap" },
  { label: "Others, specify" },
];
export const evacuationAreaOptions = [
  { value: 1, label: "1 - Barangay/Rural Health Center" },
  { value: 2, label: "2 - Barangay Hall" },
  { value: 3, label: "3 - Barangay Evacuation Center" },
  { value: 4, label: "4 - City/Municipal Evacuation Center" },
  { value: 5, label: "5 - Barangay Multi-Purpose Center" },
  { value: 6, label: "6 - City/Municipal Multi-Purpose Center" },
  { value: 7, label: "7 - Public School" },
  { value: 8, label: "8 - Private School" },
  { value: 9, label: "9 - Church" },
  { value: 10, label: "10 - Covered Court" },
  { value: 11, label: "11 - Gymnasium" },
  { value: 12, label: "12 - Public Park" },
  { value: 13, label: "13 - Relatives" },
  { value: 14, label: "14 - Neighbor" },
  { value: 15, label: "15 - Hindi nag-evacuate" },
  { value: 99, label: "99 - Others, specify" },
];
export const experiencedDisasterOptions = [{ label: "Oo" }, { label: "Hindi" }];
export const externalHouseWallOptions = [
  { value: 1, label: "1 - Asbestos/Glass" },
  { value: 2, label: "2 - Bamboo/Sawali/Cogon/Nipa" },
  { value: 3, label: "3 - Concrete/Brick/Stone" },
  { value: 4, label: "4 - Galvanized Iron/Aluminum" },
  { value: 5, label: "5 - Half-Concrete, Brick, Stone/Half Wood" },
  { value: 6, label: "6 - Makeshift/Salvaged/Improvised" },
  { value: 7, label: "7 - Wood" },
  { value: 8, label: "8 - No Walls" },
  { value: 9, label: "9 - Container Van" },
  { value: 99, label: "99 - Others, specify" },
];
export const familyTypeOptions = [
  { label: "Main Family (Owner)" },
  { label: "Extended Family" },
];
export const fishpondTypeOptions = [
  { value: 1, label: "1 - Fish Cage" },
  { value: 2, label: "2 - Fish Pond" },
];
export const fishpondOwnershipOptions = [
  { value: 1, label: "1 - Titulado" },
  { value: 2, label: "2 - Umuupa" },
  { value: 3, label: "3 - Tenant" },
  { value: 4, label: "4 - Fish Leasehold Agreement (FLA)" },
];
export const waterTypeOptions = [
  { value: 1, label: "1 - Alat (Marine)" },
  { value: 2, label: "2 - Tabsing (Brackish)" },
  { value: 3, label: "3 - Tabang (Fresh)" },
  { value: 4, label: "4 - Backyard" },
];
export const fisheriesOptions = [
  { value: 1, label: "1 - Carp" },
  { value: 2, label: "2 - Catfish" },
  { value: 3, label: "3 - Falcata" },
  { value: 4, label: "4 - Freshwater catfish (Kanduli)" },
  { value: 5, label: "5 - Freshwater goby (Biya)" },
  { value: 6, label: "6 - Freshwater Shrimp" },
  { value: 7, label: "7 - Gourami" },
  { value: 8, label: "8 - Milkfish" },
  { value: 9, label: "9 - Mudcrab" },
  { value: 10, label: "10 - Mudfish" },
  { value: 11, label: "11 - Mussel" },
  { value: 12, label: "12 - Other crustaceans" },
  { value: 13, label: "13 - Other fish species" },
  { value: 14, label: "14 - Other mollusks" },
  { value: 15, label: "15 - Others" },
  { value: 16, label: "16 - Oyster" },
  { value: 17, label: "17 - Prawn" },
  { value: 18, label: "18 - Seaweed" },
  { value: 19, label: "19 - Tilapia" },
];
export const floorMatOptions = [
  { value: 1, label: "1 - Bamboo" },
  { value: 2, label: "2 - Cement" },
  { value: 3, label: "3 - Cemented with linoleum" },
  { value: 4, label: "4 - Cemented with tiles" },
  { value: 5, label: "5 - Wood" },
  { value: 6, label: "6 - Soil" },
  { value: 7, label: "7 - Soil with linoleum" },
  { value: 99, label: "99 - Others, specify" },
];
export const foundationMaterialOptions = [
  { value: 1, label: "1 - Konkreto" },
  { value: 2, label: "2 - Hindi konkreto" },
  { value: 3, label: "3 - Hindi Alam" },
];
export const gableWallMaterialOptions = [
  { value: 1, label: "1 - Yari sa bakal" },
  {
    value: 2,
    label: "2 - Yari sa light materials, hollow blocks, at walang kabalyete",
  },
  {
    value: 3,
    label:
      "3 - Hindi maayos ang paglalagay ng hollow blocks, laryo (brick), o bato",
  },
  { value: 4, label: "4 - Hindi Alam" },
];
export const houseAffectedByDisasterOptions = [
  { value: 1, label: "1 - Oo, pero naipaayos na" },
  { value: 2, label: "2 - Oo, pero hindi pa naipaayos" },
  { value: 3, label: "3 - Hindi" },
  { value: 4, label: "4 - Hindi Alam" },
];
export const houseBuiltBefore1990Options = [
  { value: 1, label: "1 - Oo, pero naipaayos na" },
  { value: 2, label: "2 - Oo, pero hindi pa naipaayos" },
  { value: 3, label: "3 - Hindi" },
  { value: 4, label: "4 - Hindi Alam" },
];
export const houseConditionOptions = [
  { value: 1, label: "1 - Matibay" },
  { value: 2, label: "2 - Mahina/Mahuna" },
  { value: 3, label: "3 - Hindi Alam" },
];
export const houseExtensionOptions = [
  { value: 1, label: "1 - Oo, pero pinangasiwaan ng Engineer/Arkitekto" },
  { value: 2, label: "2 - Oo, pero hindi pinangasiwaan ng Engineer/Arkitekto" },
  { value: 3, label: "3 - Hindi" },
  { value: 4, label: "4 - Hindi Alam" },
];
export const houseLocationOptions = [
  { value: 1, label: "1 - Along estero/creek/waterways" },
  { value: 2, label: "2 - Along river banks/shoreline" },
  { value: 3, label: "3 - Along railroad" },
  { value: 4, label: "4 - In the garbage dumpsite" },
  { value: 5, label: "5 - Under the bridge" },
  {
    value: 6,
    label: "6 - In danger areas such as cliff, hillside, or mountain slopes",
  },
  { value: 7, label: "7 - In Temporary or permanent relocation area" },
  {
    value: 8,
    label:
      "8 - In a structure without roof/wall or in a housing unit with light materials in its roof and/or walls",
  },
  {
    value: 9,
    label:
      "9 - In government land without legally recognizable claims to the land",
  },
  { value: 10, label: "10 - In private land which they do not own" },
  { value: 99, label: "99 - Others, specify" },
];
export const ownershipOptions = [
  { value: 1, label: "1 - Pagmamay-ari" },
  { value: 2, label: "2 - Nirentahan" },
  { value: 3, label: "3 - Hinuhulugan" },
  { value: 4, label: "4 - Nagagamit ng libre nang walang pahintulot" },
  { value: 5, label: "5 - Caretaker" },
  { value: 6, label: "6 - Pagmamay-ari ng Pamilya" },
  { value: 7, label: "7 - Pagmamay-ari ng Gobyerno" },
  { value: 8, label: "8 - PNR Lot" },
  { value: 99, label: "99 - Others, specify" },
];
export const houseShapeOptions = [
  { value: 1, label: "1 - Regular" },
  { value: 2, label: "2 - Irregular" },
  { value: 3, label: "3 - Hindi Alam" },
];
export const houseStructureOptions = [
  { value: 1, label: "1 - Duplex" },
  { value: 2, label: "2 - Commercial/Industrial/Agricultural" },
  { value: 3, label: "3 - Extension" },
  { value: 4, label: "4 - Institutional Living Quarters" },
  { value: 5, label: "5 - Multi-unit Residence" },
  { value: 6, label: "6 - Single House" },
  { value: 99, label: "99 - Others, specify" },
];
export const internetProviderOptions = [
  { value: "FixedWired", label: "Fixed Wired" },
  { value: "FixedWireless", label: "Fixed Wireless" },
  { value: "Satellite", label: "Satellite Broadband" },
  { value: "Mobile", label: "Mobile Broadband Network" },
  { value: "Others", label: "Others, specify" },
];
export const householdTypes = [
  { label: "Family" },
  { label: "Institutional Household" },
];
export const socialProtectionOptions = [
  { label: "4Ps" },
  { label: "Social Pension for Senior Citizens" },
  { label: "Assistance to Individuals in Crisis Situation (AICS)" },
  { label: "Walang Gutom 2027 Food Stamp" },
  { label: "Education Assistance Programs" },
  { label: "Employment/Livelihood Assistance" },
  { label: "Others" },
];
export const mobileProviderOptions = [
  { label: "Globe", value: "Globe" },
  { label: "Smart", value: "Smart" },
  { label: "DITO", value: "DITO" },
  { label: "GOMO", value: "GOMO" },
  { label: "TM (Touch Mobile)", value: "TM" },
  { label: "TNT (Talk 'N Text)", value: "TNT" },
  { label: "Sun Cellular", value: "Sun Cellular" },
  { label: "Others", value: "Others" },
];
export const roofingMatOptions = [
  { value: 1, label: "1 - Bamboo/Sawali/Cogon/Nipa" },
  { value: 2, label: "2 - Galvanized Iron/Aluminum" },
  { value: 3, label: "3 - Makeshift/Salvaged/Improvised" },
  { value: 4, label: "4 - Mixed materials but more of cogon/nipa/anahaw" },
  { value: 5, label: "5 - Mixed materials but more of galvanized iron" },
  { value: 6, label: "6 - Cement" },
  { value: 7, label: "7 - Wood" },
  {
    value: 8,
    label: "8 - Mixed materials but more of makeshift/salvaged/improvised",
  },
  { value: 99, label: "99 - Others, specify" },
];
export const soilConditionOptions = [
  { value: 1, label: "1 - Matigas" },
  { value: 2, label: "2 - Malambot" },
  { value: 3, label: "3 - Hindi Alam" },
];
export const sourceElectOptions = [
  { value: 1, label: "1 - Electricity" },
  { value: 2, label: "2 - Kerosene (Gaas)" },
  { value: 3, label: "3 - LPG" },
  { value: 4, label: "4 - Battery" },
  { value: 5, label: "5 - Biogas" },
  { value: 6, label: "6 - Solar Energy" },
  { value: 7, label: "7 - Barangay Generator" },
  { value: 8, label: "8 - No Electricity" },
  { value: 99, label: "99 - Others, Specify" },
];
export const steelStandardOptions = [
  {
    value: 1,
    label:
      "1 - Oo, 10 mm na bakal ang ginamit, nakatali at naayon sa tamang pagitan",
  },
  { value: 2, label: "2 - Hindi, kakaunti at mas maliit sa 10mm na bakal" },
  { value: 3, label: "3 - Walang bakal na ginamit" },
  { value: 4, label: "4 - Hindi Alam" },
];
export const wallSupportOptions = [
  {
    value: 1,
    label:
      "1 - Wala, lahat ng suportadong dingding ay mas makitid sa 3 metrong luwang",
  },
  {
    value: 2,
    label:
      "2 - Oo, isa lamang ang dingding na walang suporta o tukod may luwang na higit 3 metro",
  },
  { value: 3, label: "3 - Hindi Alam" },
];
export const wallThicknessOptions = [
  { value: 1, label: "1 - Oo" },
  { value: 2, label: "2 - Hindi" },
  { value: 3, label: "3 - Hindi Alam" },
];
export const classOfWorkerOptions = [
  { label: "1-Private Household" },
  { label: "2-Private Establishment" },
  { label: "3-Govt/Govt Corp" },
  { label: "4-Self-employed" },
  { label: "5-Employer" },
  { label: "6-Paid Family Farm/Biz" },
  { label: "7-Unpaid Family Farm/Biz" },
  { label: "8-Not Applicable" },
];
export const contraceptiveOptions = [
  { label: "Oral Contraceptives" },
  { label: "Injectable Contraceptives" },
  { label: "Subdermal Implants" },
  { label: "IUD" },
  { label: "Condom" },
  { label: "Spermicide" },
  { label: "Calendar-based Method" },
  { label: "Basal Body Temperature Method" },
  { label: "Lactational Amenorrhea Method" },
  { label: "Tubal Ligation" },
  { label: "Vasectomy" },
  { label: "Not using contraceptives" },
  { label: "Not Applicable" },
  { label: "Others, specify" },
];
export const dewormingStatusOptions = [
  { label: "1 Dewormed" },
  { label: "2 Not Dewormed" },
];
export const isEverPregnantOptions = [{ label: "Yes" }, { label: "No" }];
export const genderOptions = [
  { label: "L - Lesbian" },
  { label: "G - Gay" },
  { label: "B - Bisexual" },
  { label: "T - Transgender" },
  { label: "Others, specify" },
  { label: 'Not Applicable' }
];
export const healthInsuranceOptions = [
  { label: "1 – Social Security System (SSS)" },
  { label: "2 – Government Service Insurance System (GSIS)" },
  { label: "3 – Philhealth" },
  { label: "4 – Cooperative/LGU Health Card" },
  { label: "5 – Dependent" },
  { label: "6 - None" },
  { label: "Others, specify" },
];
export const ifaIntakeOptions = [
  { label: "Weekly" },
  { label: "Monthly" },
  { label: "Never" },
];
export const ifaSourceOptions = [
  { label: "School" },
  { label: "Health Center/RHU" },
  { label: "Bought by Household" },
  { label: "Others, specify" },
];
export const lactationStatusOptions = [
  { label: "Currently lactating" },
  { label: "Not lactating" },
];
export const migrationStatusOptions = [
  { label: "NM - Non-migrant (>5 years)" },
  { label: "M - Migrant (>=6 months)" },
  { label: "T - Transient" },
];
export const pregnancyStatusOptions = [
  { label: "Currently pregnant" },
  { label: "Not pregnant" },
];
export const prenatalCheckupOptions = [
  { label: "Goes to prenatal check-ups" },
  { label: "Does not go to prenatal check-ups" },
];
export const civilRegisteredOptions = [
  { label: "Yes - Registered" },
  { label: "No - Not registered" },
];
export const registeredVoterOptions = [
  { label: "Yes - Registered here" },
  { label: "No - Registered elsewhere" },
  { label: "NR - Not registered" },
  { label: "NA - Not yet voter" },
];
export const relationshipOptions = [
  { label: "1 - Adopted" },
  { label: "2 - Brother/Sister" },
  { label: "3 - Brother/Sister-in-Law" },
  { label: "4 - Child" },
  { label: "5 - Daughter/Son-in-Law" },
  { label: "6 - Employee" },
  { label: "7 - Grandchild" },
  { label: "8 - Grandparent" },
  { label: "9 - Head of the Family" },
  { label: "10 - Housemaid" },
  { label: "11 - Live in/Co-habit" },
  { label: "12 - Niece/Nephew" },
  { label: "13 - Parent" },
  { label: "14 - Parent-in-Law" },
  { label: "15 - Relative" },
  { label: "16 - Spouse" },
  { label: "17 - Step Son/Daughter" },
  { label: "18 - Step Parent" },
  { label: "19 - Student" },
  { label: "20 - Not Related" },
  { label: "Others, Specify" },
];
export const schoolingReasonsOptions = [
  { label: "1 Accessibility" },
  { label: "2 Illness" },
  { label: "3 Disability" },
  { label: "4 Pregnancy" },
  { label: "5 Marriage" },
  { label: "6 Cost/Financial" },
  { label: "7 Employment" },
  { label: "8 Finished" },
  { label: "9 Looking for Work" },
  { label: "10 Lack of Interest" },
  { label: "11 Too Young" },
  { label: "12 Bullying" },
  { label: "13 Family Matters" },
  { label: "14 No/Weak Internet" },
  { label: "15 Modular Not Preferred" },
  { label: "16 Problem w/ Requirements" },
  { label: "17 Lack Of Confidence" },
  { label: "18 Oral Health Issue" },
  { label: "Others, Specify" },
];
export const schoolingStatusOptions = [
  { label: "1 Currently Studying" },
  { label: "2 Not Studying" },
];
export const seekingWorkOptions = [
  { label: "1 - Actively seeking" },
  { label: "2 - Not actively seeking" },
  { label: "3 - Employed" },
];
export const sexOptions = [{ label: "F - Female" }, { label: "M - Male" }];
export const educationalAttainmentOptions = [
  { label: "NS–No Schooling" },
  { label: "DC–Day Care" },
  { label: "K–Kinder" },
  { label: "E1" },
  { label: "E2" },
  { label: "E3" },
  { label: "E4" },
  { label: "E5" },
  { label: "E6" },
  { label: "Elem Grad" },
  { label: "HS1" },
  { label: "HS2" },
  { label: "HS3" },
  { label: "HS4" },
  { label: "HSG" },
  { label: "JHS7" },
  { label: "JHS8" },
  { label: "JHS9" },
  { label: "JHS10" },
  { label: "JHS Grad" },
  { label: "SHS11" },
  { label: "SHS12" },
  { label: "SHS Grad" },
  { label: "C1" },
  { label: "C2" },
  { label: "C3" },
  { label: "C4" },
  { label: "C5" },
  { label: "C6" },
  { label: "College Grad" },
  { label: "P–Postgraduate" },
  { label: "V–Vocational" },
];
export const soloParentOptions = [
  { label: "1 Yes" },
  { label: "2 No" },
  { label: "3 Not Applicable" },
];
export const feedingStatusOptions = [
    {label: "1 Exclusively Breastfed"},
    {label: "2 Breastfeed + Formula Milk"},
    {label: "3 Formula Milk only"},
    {label: "4 Breastfeed + Complementary Food"},
    {label: "5 Formula Milk + Complementary Food"},
    {label: "6 Breastmilk + Formula Milk + Complementary Food"},
    {label: "7 Complementary Food Only"}
];
export const skillsOptions = [
  {label: 'Crop farming and gardening'},
  {label: 'Livestock and poultry raising'},
  {label: 'Fishing and aquaculture'},
  {label: 'Agroforestry'},
  {label: 'Carpentry'}, 
  {label: 'Masonry'},
  {label: 'Plumbing'},
  {label: 'Electrical installation and maintenance'},
  {label: 'Welding and fabrication'},
  {label: 'Housekeeping'},
  {label: 'Food and beverage services'},
  {label: 'Cooking and baking'},
  {label: 'Hotel and restaurant services'},
  {label: 'Caregiving (elderly, children)'},
  {label: 'Buying and selling (retail trading)'},
  {label: 'Sari-sari store management'},
  {label: 'Merketing and sales'},
  {label: 'Handicraft production'},
  {label: 'Basic computer operation'},
  {label: 'Word processing and data entry'},
  {label: 'Social media marketing'},
  {label: 'Basic graphic design'},
  {label: 'Driving'},
  {label: 'Vehicle repair and maintenance'},
  {label: 'Heavy equipment operation'},
  {label: 'Painting'},
  {label: 'Tiling and flooring'},
  {label: 'Garments production'},
  {label: 'Handicrafts and furniture making'},
  {label: 'Food processing'},
  {label: 'Others, specify'},
  {label: 'Not Applicable'}
];
export const bilangPunoAniUnit = [
  {label: 'Puno'},
  {label: 'Sako/Kaban'},
  {label: 'Kg'},
  {label: 'Ton'}
];
export const withSeniorIdOptions = [
  {label: '1 Yes'},
  {label: '2 No'},
  {label: '3 Not Applicable'}
];
export const isOFWOptions = [
  {label: '1 - Yes'},
  {label: '2 - No'}
]